import type {
  AutocompleteField as AutocompleteFieldType,
  ReportFormData,
} from '@/screens/ReportCreation/reportCreation.types';
import { FieldValues, useController } from 'react-hook-form';
import { YStack } from 'tamagui';
import { FieldError } from '../FieldError';
import type { ControlledFieldController } from '../formController.types';
import { AutocompleteField } from './AutocompleteField';

interface ControlledAutocompleteFieldProps<FormValues extends FieldValues> {
  field: AutocompleteFieldType;
  formController: ControlledFieldController<FormValues>;
}

export const ControlledAutocompleteField = <
  FormValues extends FieldValues = ReportFormData,
>({
  field,
  formController,
}: ControlledAutocompleteFieldProps<FormValues>): React.ReactElement => {
  const { field: controllerField, fieldState } = useController<FormValues>({
    ...formController,
  });

  const value =
    typeof controllerField.value === 'string' ? controllerField.value : '';

  return (
    <YStack gap="$1">
      <AutocompleteField
        label={field.label}
        placeholder={field.placeholder}
        value={value}
        onValueChange={controllerField.onChange}
        options={field.options}
        required={field.required}
        allowCustomValue={field.allowCustomValue}
        helperText={field.helperText}
      />
      <FieldError message={fieldState.error?.message} />
    </YStack>
  );
};
